import { useEffect, useState } from "react";

// TRE-2313 — wskaźnik pracy asystenta na wzór Claude Code: pulsujący znak, który przechodzi
// przez kolejne kształty gwiazdki, migoczący czasownik i licznik sekund. Gdy trwa krok
// narzędzia, zamiast czasownika stoi jego nazwa (np. „Sprawdzam aktywność”).

const GLYPHS = ["·", "✢", "✳", "✶", "✻", "✽", "✻", "✶", "✳", "✢"];
const GLYPH_INTERVAL_MS = 120;
const VERB_INTERVAL_MS = 2800;
const VERBS = ["Myślę", "Szukam", "Analizuję", "Przeglądam dane", "Zbieram fakty", "Układam odpowiedź"];

const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const ThinkingIndicator = ({ label }: { label?: string | null }) => {
  const [tick, setTick] = useState(0);
  const [startedAt] = useState(() => Date.now());
  const reducedMotion = prefersReducedMotion();

  useEffect(() => {
    const timer = window.setInterval(() => setTick((value) => value + 1), GLYPH_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  const elapsedMs = tick * GLYPH_INTERVAL_MS;
  const seconds = Math.floor((Date.now() - startedAt) / 1000);
  const glyph = reducedMotion ? "✻" : GLYPHS[tick % GLYPHS.length];
  const verb = label ?? VERBS[Math.floor(elapsedMs / VERB_INTERVAL_MS) % VERBS.length];

  return (
    <div className="not-typeset flex items-center gap-2 text-[13px] leading-5" role="status" aria-live="polite">
      <span aria-hidden className="inline-block w-3.5 text-center text-[15px] font-semibold text-amber-600">
        {glyph}
      </span>
      <span className="chat-shimmer">{verb}…</span>
      {seconds >= 2 ? <span className="tabular-nums text-gray-400">{seconds} s</span> : null}
    </div>
  );
};
